var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgPartnerHired(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 300.411,
    height: 264.494,
    viewBox: "0 0 300.411 264.494",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "Ellipse_647",
    x: 62.939,
    y: 0,
    width: 197.715,
    height: 197.715,
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dy: 10,
    input: "SourceAlpha"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 15,
    result: "blur"
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0.161
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in2: "blur"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "SourceGraphic"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_32031",
    "data-name": "Group 32031",
    transform: "translate(-819.764 -186.627)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_32030",
    "data-name": "Group 32030",
    transform: "translate(950.662 282.616)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_13214",
    "data-name": "Path 13214",
    d: "M130.789,88.475a7.6,7.6,0,0,0-5.984,1.282c-2.718,1.995-7.376,4.647-12.055,3.726-7.266-1.436-11.211-8.252-9.589-16.439S111,63.97,118.274,65.406c4.7.921,8.011,5.129,9.776,8.011a7.729,7.729,0,0,0,14.116-2.641l8.066-48.506L74.261,9,22.335,0l-8.11,46.029c-.822,4.187,2.7,7.9,6.883,8.768A7.573,7.573,0,0,0,27.081,53.5c2.718-1.995,7.387-4.647,12.055-3.726,7.277,1.436,11.222,8.252,9.6,16.494S40.89,79.346,33.613,77.91c-4.691-.921-8.011-5.129-9.776-8.011a7.7,7.7,0,0,0-14.1,2.63L0,126.735l76.409,13.447,44.824,7.891,5.48.975L136.85,97.615a7.672,7.672,0,0,0-6.061-9.14Z",
    transform: "translate(0 20.908) rotate(-8)",
    fill: "#3d92c6"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_13215",
    "data-name": "Path 13215",
    d: "M123.357,193.777a7.721,7.721,0,0,1-13.633,4.439c-2.115-2.608-5.94-6.335-10.7-6.576-7.365-.46-12.877,5.118-13.4,13.469s4.263,14.565,11.639,15.025c4.756.3,9.009-2.926,11.431-5.25a7.6,7.6,0,0,1,5.732-2.071,7.672,7.672,0,0,1,7.2,8.154l-3.288,52.1L234.277,278l2.51-54.8a7.672,7.672,0,0,1,8.154-7.2c2.133.11,4.122,2.208,5.48,3.858,2.115,2.608,5.94,6.335,10.7,6.63,7.365.46,12.888-6.214,13.4-14.565s-4.263-15.661-11.628-16.121c-4.756-.3-9.02,2.926-11.442,5.25-1.536,1.463-3.615,3.31-5.732,3.167-4.241-.263-8.187-3.474-7.924-7.672l1.973-46.512L124.957,145.15Z",
    transform: "translate(734.18 150.537)",
    fill: "#59c0ea"
  }), /*#__PURE__*/React.createElement("g", {
    id: "freepik--speech-bubble-2--inject-22",
    transform: "matrix(0.951, 0.309, -0.309, 0.951, 954.119, 221.627)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0.95, -0.31, 0.31, 0.95, -138.59, 8.23)",
    filter: "url(#Ellipse_647)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_647-2",
    "data-name": "Ellipse 647",
    cx: 42.742,
    cy: 42.742,
    r: 42.742,
    transform: "matrix(0.95, 0.31, -0.31, 0.95, 134.35, 35)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_13083",
    "data-name": "Path 13083",
    d: "M18.65,31.2,0,18.729l4.351-6.5,12.508,8.356L32.4,0l6.247,4.722Z",
    transform: "translate(23.416 28.367)",
    fill: "#00ff1d"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPartnerHired);
export default __webpack_public_path__ + "static/media/partner_hired.fec38fc7cd2eb276168a694cea931e47.svg";
export { ForwardRef as ReactComponent };